import { DateTime } from 'luxon';
import React, { ReactElement } from 'react';
import { SensorData } from '../../../Model/sensorData';

interface SensorDataTableColumn<T> {
  label: string;
  value: ((sensor: T) => string | number | ReactElement);
}

export class SensorDataMapper {

  static getTableColumns(type: 'airqino' | 'turtle') {
    if (type === 'airqino') {
      return SensorDataMapper.getTableColumnsForAirqino();
    }
    if (type === 'turtle') {
      return SensorDataMapper.getTableColumnsForTurtle();
    }
    return [];
  }

  private static getTableColumnsForAirqino(): SensorDataTableColumn<SensorData>[] {
    return [
      { label: 'Humidity', value: (sensor) => sensor.humidity },
      { label: 'Temp', value: (sensor) => sensor.temperature },
      { label: 'GPS', value: (sensor) => sensor.gps },
      { label: 'PM2.5', value: (sensor) => sensor.pm2_5 },
      { label: 'CO', value: (sensor) => sensor.type === 'airqino' ? sensor.co : '' },
      { label: 'NO2', value: (sensor) => sensor.type === 'airqino' ? sensor.no2 : '' },
      { label: 'O3', value: (sensor) => sensor.type === 'airqino' ? sensor.o3 : '' },
      { label: 'PM10', value: (sensor) => sensor.pm10 }
    ];
  }

  private static getTableColumnsForTurtle(): SensorDataTableColumn<SensorData>[] {
    return [
      {
        label: 'Weather',
        // eslint-disable-next-line react/display-name
        value: (sensor) => <>
          <table>
            <tbody>
              <tr>
                <th>Humidity</th>
                <td>{sensor.humidity}</td>
              </tr>
              <tr>
                <th>Temp</th>
                <td>{sensor.temperature}</td>
              </tr>
            </tbody>
          </table>
        </>
      },
      {
        label: 'GPS',
        // eslint-disable-next-line react/display-name
        value: (sensor) => <>
          <table>
            <tbody>
              <tr>
                <th>GPS</th>
                <td>{sensor.gps}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{sensor.type === 'turtle' ? (sensor.gpsStatus ? 'ok' : 'ko') : ''}</td>
              </tr>
            </tbody>
          </table>
        </>
      },
      {
        label: 'Device data',
        // eslint-disable-next-line react/display-name
        value: (sensor) => <>
          <table>
            <tbody>
              <tr>
                <th>PM2.5</th>
                <td>{sensor.pm2_5}</td>
              </tr>
              <tr>
                <th>PM10</th>
                <td>{sensor.pm10}</td>
              </tr>
              <tr>
                <th>RSSI</th>
                <td>{sensor.type === 'turtle' ? sensor.rssi : ''}</td>
              </tr>
              <tr>
                <th>Tint</th>
                <td>{sensor.type === 'turtle' ? sensor.tint : ''}</td>
              </tr>
              <tr>
                <th>VBAT</th>
                <td>{sensor.type === 'turtle' ? sensor.vbat : ''}</td>
              </tr>
              <tr>
                <th>VPAN</th>
                <td>{sensor.type === 'turtle' ? sensor.vpan : ''}</td>
              </tr>
            </tbody>
          </table>
        </>
      },
      {
        label: 'Device info',
        // eslint-disable-next-line react/display-name
        value: (sensor) => <>
          <table>
            <tbody>
              <tr>
                <th>MAC</th>
                <td>{sensor.type === 'turtle' ? sensor.mac : ''}</td>
              </tr>
              <tr>
                <th>UTC</th>
                <td>{
                  sensor.type === 'turtle' && sensor.utcDate
                    ? DateTime.fromJSDate(new Date(sensor.utcDate)).toFormat('dd/LL/yyyy HH:mm')
                    : ''
                }</td>
              </tr>
              <tr>
                <th>FWR</th>
                <td>{sensor.type === 'turtle' ? sensor.fwr : ''}</td>
              </tr>
              <tr>
                <th>Counter</th>
                <td>{sensor.type === 'turtle' ? sensor.counter : ''}</td>
              </tr>
              <tr>
                <th>Date MS</th>
                <td>{sensor.type === 'turtle' ? sensor.dateMeasurement : ''}</td>
              </tr>
            </tbody>
          </table>
        </>
      }
    ];
  }

}